import React, { useState } from 'react';

import { Button } from '@depop/web-ui-kit/Button';
import { InputV2 } from '@depop/web-ui-kit/InputV2';
import { setCookie } from 'cookies-next/client';

import styles from './styles.module.css';

import { ACCESS_TOKEN_KEY, ACCESS_TOKEN_OPTS } from '@/constants/cookies';
import { login } from '@/modules/login/api';
import { requestMagicLinkSync } from '@/modules/magicLinks/api';

export function SwitchUser() {
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  function onInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    setInputValue(e.target.value);
  }

  async function handleSubmit(e: React.SubmitEvent<HTMLFormElement>) {
    e.preventDefault();
    setIsLoading(true);

    try {
      const {
        data: { token: magic_link_token },
      } = await requestMagicLinkSync(inputValue);
      const {
        data: { access_token },
      } = await login({ magic_link_token });

      setCookie(ACCESS_TOKEN_KEY, access_token, ACCESS_TOKEN_OPTS);
      window.location.reload();
    } catch {
      setIsLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <InputV2
        labelText="Username or email"
        id="adminTool__magic-link-login"
        onChange={onInputChange}
        onClear={() => setInputValue('')}
        value={inputValue}
        required
        className={styles.userInput}
        disabled={isLoading}
      />
      <Button type="submit" block isLoading={isLoading} disabled={isLoading}>
        Log in
      </Button>
    </form>
  );
}
